'use client';

import {
  LOCAL_STORAGE_KEYS,
  removeLocalStorageValue
} from '@/services/localStorage.service';
import { PAGE_NAME, getPageURL } from 'services/partnerPortal.service';

export const getBreadCrumbs = ({ props }) => [
  {
    name: 'Home',
    link: getPageURL({
      pageName: PAGE_NAME.HOME.label
    }),
    onClick: () =>
      removeLocalStorageValue({
        keys: [
          LOCAL_STORAGE_KEYS.DATE_PICKER_VALUE,
          LOCAL_STORAGE_KEYS.DATE_RANGE
        ]
      })
  },
  ...props
];

export const copyToClipBoard = (text) =>
  navigator.clipboard?.writeText(text).then();

export const isBrowser = () => typeof window !== 'undefined';

export const parseNumberedLabel = (value) =>
  value && value !== 'NA' ? `# ${value}` : 'NA';
